module.exports = __webpack_public_path__ + "img/84.b1240d97.png";